export default __webpack_public_path__ + "static/media/further-devices.39645b89.PNG";